const initialState = null;

const partnerships = (state = initialState, action) => {
	switch (action.type) {
		case 'GET_PARTNERSHIP_DATA_SUCCESS':
			return Object.assign([],state, {...action.payload} );
		case 'GET_PARTNERSHIP_DATA_FAILURE':
			return Object.assign([],state, []);
		default:
			return state;
	}
};

export default partnerships;


// WEBPACK FOOTER //
// ../q-cars/src/redux/reducers/partnerships.js